<template>
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div class="dialog">
        <header class="dialog-header">
          <h2 class="sr-only">검색 팝업</h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: 검색영역 -->
            <div class="mo-search-wrap">
              <div class="c-search">
                <h2 class="sr-only">검색 영역</h2>
                <form class="search-form" @submit.prevent="search">
                  <label class="sr-only">제품검색</label>
                  <input
                    type="search"
                    title="검색"
                    class="search-input"
                    autocomplete="off"
                    placeholder="제품코드/제품명 입력"
                    ref="keywordEl"
                    :value="keyword"
                    @input="handleSearchInput"
                  />
                  <button
                    type="button"
                    class="search-cancel"
                    @click.prevent="() => (keyword = '')"
                  >
                    <i class="c-icon icon-large-x"></i>
                    <span class="sr-only">검색어 재입력</span>
                  </button>
                  <button type="submit" class="search-submit">
                    <span class="sr-only">검색</span>
                  </button>
                </form>
              </div>

              <!-- D: 탭 전체 -->
              <!-- D: 탭 버튼 -->
              <div v-show="!isShowAutoKeyword" class="c-text-tabs type-small">
                <ul>
                  <li class="tab-item">
                    <!-- D: is-active, 추가 활성화 -->
                    <a
                      href="#tab1-1"
                      class="tab-anchor"
                      :class="{ 'is-active': isShowLatestKeywordTab }"
                      role="tab"
                      aria-selected
                      @click.prevent="() => (isShowLatestKeywordTab = true)"
                    >
                      최근검색어
                    </a>
                  </li>
                  <li class="tab-item">
                    <a
                      href="#tab1-2"
                      class="tab-anchor"
                      :class="{ 'is-active': !isShowLatestKeywordTab }"
                      role="tab"
                      @click.prevent="() => (isShowLatestKeywordTab = false)"
                    >
                      인기검색어
                    </a>
                  </li>
                </ul>
              </div>

              <div class="tab-panel-wrap" v-if="!isShowAutoKeyword">
                <!-- D: 탭 내용: 최근 검색어 -->
                <div
                  v-if="isShowLatestKeywordTab"
                  id="tab1-1"
                  class="tab-panel"
                  role="tabpanel"
                >
                  <h3 class="sr-only">최근 검색어 탭 내용</h3>
                  <RecentSearchesCont @select="onLatestKeywordSelect" />
                </div>

                <!-- D: 탭 내용: 인기 검색어 -->
                <div
                  v-if="!isShowLatestKeywordTab"
                  id="tab1-2"
                  class="tab-panel"
                  role="tabpanel"
                >
                  <h3 class="sr-only">인기 검색어 탭 내용</h3>
                  <PopularSearchCont @select="onLatestKeywordSelect" />
                </div>
              </div>

              <!-- D: 입력시 노출, 탭 숨김 -->
              <AutoKeywordList
                v-if="isShowAutoKeyword"
                :shwrd="keyword"
                @select="onLatestKeywordSelect"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </AbstractPop>
</template>
<script setup>
import { onMounted, defineEmits, defineProps, ref, computed } from "vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import RecentSearchesCont from "@/components/paintpro/prod/recentSearchesCont.vue";
import PopularSearchCont from "@/components/paintpro/prod/popularSearchCont.vue";
import AutoKeywordList from "@/components/paintpro/prod/searchAutoKeywordList.vue";
import Utils from "@/js/utils";

const emits = defineEmits(["close", "keywordChanged"]);

const props = defineProps({
  keyword: {
    type: String,
    default: "",
  },
});

const keyword = ref(props.keyword);
const keywordEl = ref(null);

const isShowLatestKeywordTab = ref(true); // 최근검색어탭 표시여부 true: 최근검색어탭/ false: 인기검색어탭

onMounted(() => {
  keywordEl.value.focus();
});

const isShowAutoKeyword = computed(() => {
  // 자동완성 키워드 표시여부 true: 자동완성 / false: 최근/인기 검색 레이어어
  return Utils.isNotBlank(keyword.value);
});

const search = () => {
  emits("keywordChanged", keyword.value.trim());
  emits("close");
};

const onLatestKeywordSelect = async (selectedKeyword) => {
  keyword.value = selectedKeyword;
  search();
};

const handleSearchInput = (event) => {
  // 한글 입력 후 마우스 클릭 시 순간적으로 입력값이 없어지고 재 작성되는 현상때문에 setTimeout을 설정함
  setTimeout(() => {
    keyword.value = event.target.value;
  }, 10);
};
</script>
